import { render, staticRenderFns } from "./cliente_institucion.vue?vue&type=template&id=54655ece"
import script from "./cliente_institucion.vue?vue&type=script&lang=js"
export * from "./cliente_institucion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports